export enum LoadState {
  notLoaded = 'NOT_LOADED',
  loading = 'LOADING',
  loaded = 'LOADED',
  error = 'ERROR',
}

export default LoadState;
